import { ticketStatusLabel } from '@/shared/config';
import type { Notification } from '@/entities/notification';

export function formatNotificationTitle(n: Notification): string {
  let title = n.title ?? 'Изменение в обращении';
  if (n.eventType === 'status_changed' && n.payload) {
    for (const key of ['oldStatus', 'newStatus'] as const) {
      const raw = n.payload[key];
      if (typeof raw === 'string' && raw) {
        title = title.split(raw).join(ticketStatusLabel(raw));
      }
    }
  }
  return title;
}
